export default __webpack_public_path__ + "static/media/04.96d11b00.jpg";